module.exports = __webpack_public_path__ + "img/duels.0ac1b8c7.webp";